<script>
export default {
  props: {
    form: {
      required: true,
    },
    'groupClasses': {
      type: String,
      required: false
    },
    'modelValue': {
      required: true
    },
    'type': {
      type: String,
      default: 'text'
    },
    'id': {
      type: String,
      required: false
    },
    'name': {
      type: String,
      required: true
    },
    'label': {
      type: String,
      required: false
    }
  },
  inheritAttrs: false,
  emits: ['update:modelValue'],
  computed: {
    renderedId() {
      return this.id ?? this.name;
    },
    hasError() {
      return (this.form.errors[this.name] ?? null) != null;
    }
  },
  methods: {
    changeModelValue(event) {
      delete this.form.errors[this.name];
      this.$emit('update:modelValue', event.target.value);
    }
  }
}
</script>

<template>
  <div :class="{
    'form-group': true,
    [groupClasses]: groupClasses,
  }">
    <label v-if="label" :for="renderedId" :class="{'form-label': true, 'text-danger': hasError}">{{ label }}</label>
    <input
        :name="name"
        v-bind="$attrs"
        @input="changeModelValue"
        :type="type"
        :id="renderedId"
        :class="{'form-control': true, 'border-danger': hasError}"
        :value="modelValue"
    >
    <label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
  </div>
</template>